//react
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import sha256 from 'crypto-js/sha256';

//data
import dataSiteMap from '../../siteMap.json';

class PageRequestValidator extends Component {
	cultureExists(culture, section) {
		for (const existingCulture of Object.keys(dataSiteMap)) {
			if (culture === existingCulture && dataSiteMap[existingCulture].live) {
				return dataSiteMap[existingCulture].cultureCode;
			}
		}

		return false;
	}

	sectionExists(culture, section) {
		if (!dataSiteMap[culture].navigation) {
			return false;
		}

		return dataSiteMap[culture].navigation[section];
	}

	pageExists(culture, section, page) {
		if (!dataSiteMap[culture].navigation) {
			return false;
		}

		if (!dataSiteMap[culture].navigation[section]) {
			return false;
		}

		if (!dataSiteMap[culture].navigation[section].pages) {
			return false;
		}

		const matchingPages = dataSiteMap[culture].navigation[section].pages.filter(({key}) => key === page);

		if (matchingPages[0]) {
			//is the requested page live?
			if (matchingPages[0].live) {
				return true;
			}
		}

		return false;
	}

	setCookie(cultureCode) {
		if (cultureCode !== 'global') {
			const today = new Date();
			let expire = new Date();

			expire.setTime(today.getTime() + 3600000 * 24 * 14);
			document.cookie = 'culturePreference=' + cultureCode + ';expires=' + expire.toGMTString() + ';path=/';
		}
	}

	render() {
		const culture = this.props.culture;
		const section = this.props.section;
		const page = this.props.page;

		const cultureCode = this.cultureExists(culture, section);

		if (cultureCode) {
			//check for global landing page request
			if (culture === 'global' && !section) {
				return (
					<Redirect to={'/page-not-found?request=' + window.location.pathname} />
				);
			}

			//check for HCP login requirements
			if (dataSiteMap[culture].hcpLogin && section === 'hcp') {
				const key1 = window.sessionStorage.getItem(culture + 'Key1');
				const key2 = window.sessionStorage.getItem(culture + 'Key2');

				if (key1 !== sha256(dataSiteMap[culture].hcpLogin[dataSiteMap[culture].hcpLogin.length - 1].key1).toString() || key2 !== sha256(dataSiteMap[culture].hcpLogin[dataSiteMap[culture].hcpLogin.length - 1].key2).toString()) {
					return (
						<Redirect to={'/' + culture} />
					);
				}
			}

			//is the section request for a legal page?
			let matchingLegalPages = dataSiteMap[culture].navigation.legal.pages.filter(({key}) => key === section);

			if (matchingLegalPages[0]) {
				//is the requested page live?
				if (matchingLegalPages[0].live) {
					return null;
				}
			}

			//is the page request for a legal page?
			matchingLegalPages = dataSiteMap[culture].navigation.legal.pages.filter(({key}) => key === page);

			if (matchingLegalPages[0]) {
				//is the requested page live?
				if (matchingLegalPages[0].live) {
					return null;
				}
			}

			//culture found, set cookie
			this.setCookie(cultureCode);

			if (section && !this.sectionExists(culture, section)) {
				//section not found
				return (
					<Redirect to={'/' + culture + '/page-not-found?request=' + window.location.pathname} />
				);
			} else if (page && !this.pageExists(culture, section, page)) {
				//page not found
				return (
					<Redirect to={'/' + culture + '/' + section + '/page-not-found?request=' + window.location.pathname} />
				);
			}
		} else {
			//culture not found
			return (
				<Redirect to={'/page-not-found?request=' + window.location.pathname} />
			);
		}

		return null;
	}
}

export default PageRequestValidator;



// WEBPACK FOOTER //
// ./src/components/pageRequestValidator/pageRequestValidator.js